import dataAccessor, {DataAccessor} from 'ui-library/charting/internals/utils/dataAccessor';
import {AxisTypes, CartesianPoint} from 'ui-library/charting/Types';

export default function getCartesianAccessors(axisTypes: AxisTypes): {
  xAccessor: DataAccessor<CartesianPoint>;
  yAccessor: DataAccessor<CartesianPoint>;
} {
  return {
    xAccessor: dataAccessor<CartesianPoint, 'x'>('x', axisTypes.x),
    yAccessor: dataAccessor<CartesianPoint, 'y'>('y', axisTypes.y),
  };
}
